export type SelectOptionObject = {
  value: string | number
  label: string | number
  ariaLabel: string
}

/**
 * Build an array of SelectOptionObject
 *
 * @method buildSelectOptions
 * @param  {number} iterations how many items will be in array
 * @param  {[Function]} args a list of parameters for the factorySelectOption function
 * @return {Array<SelectOptionObject>}
 */
export const buildSelectOptions = (
  iterations: number,
  args: Function,
): SelectOptionObject[] => {
  return [...Array(iterations).keys()].map((number) => {
    return factorySelectOption(number + 1, args)
  })
}

/**
 * @method factorySelectOption
 * @param  {any} value
 * @param  {Function} factoryAriaLabel function to use in ariaLabel property
 * @return {SelectOptionObject}
 */
export const factorySelectOption = (
  value: number,
  factoryAriaLabel: Function,
): SelectOptionObject => {
  return {
    value: value,
    label: `${value}`,
    ariaLabel: factoryAriaLabel(value),
  }
}
